import React from 'react'
import { RoomInfo } from '../room-info'
import { RoomType } from '../availability-tab/type'

interface Props {
  room: RoomType
}

export const RoomInfoButton = ({ room }: Props): React.JSX.Element => {
  const [isSearchModalOpen, setIsModalOpen] = React.useState(false)
  const openModal = () => {
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }

  return (
    <>
      <button
        type="button"
        onClick={openModal}
        className="object-contain cursor-pointer flex items-center justify-center border-2 text-green border-green-500 px-4 py-3 rounded-md hover:bg-green-50 w-full"
      >
        <i className="fa-solid fa-calendar-days mr-2"></i>
        詳しく見る
      </button>

      {isSearchModalOpen && <RoomInfo room={room} close={closeModal} />}
    </>
  )
}
